export const timezoneEndpoints = {
    get: '/v3/timezones'
}